module.exports = __webpack_public_path__ + "static/media/logo@3x.d091e327.png";